var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLock20 = function SvgIcLock20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6587_3159",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6587_3159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lock_2",
    d: "M5.49417 18C5.08139 18 4.72917 17.8531 4.4375 17.5594C4.14583 17.2656 4 16.9125 4 16.5V8.5C4 8.0875 4.14687 7.73438 4.44062 7.44063C4.73437 7.14688 5.0875 7 5.5 7H6V5C6 3.89333 6.39049 2.95 7.17146 2.17C7.95229 1.39 8.89674 1 10.0048 1C11.1127 1 12.0556 1.39 12.8333 2.17C13.6111 2.95 14 3.89333 14 5V7H14.5C14.9125 7 15.2656 7.14688 15.5594 7.44063C15.8531 7.73438 16 8.0875 16 8.5V16.5C16 16.9125 15.8531 17.2656 15.5592 17.5594C15.2653 17.8531 14.9119 18 14.4992 18H5.49417ZM5.5 16.5H14.5V8.5H5.5V16.5ZM10.0044 14C10.4181 14 10.7708 13.8527 11.0625 13.5581C11.3542 13.2635 11.5 12.9094 11.5 12.4956C11.5 12.0819 11.3527 11.7292 11.0581 11.4375C10.7635 11.1458 10.4094 11 9.99563 11C9.58188 11 9.22917 11.1473 8.9375 11.4419C8.64583 11.7365 8.5 12.0906 8.5 12.5044C8.5 12.9181 8.64729 13.2708 8.94187 13.5625C9.23646 13.8542 9.59062 14 10.0044 14ZM7.5 7H12.5V5C12.5 4.30556 12.2569 3.71528 11.7708 3.22917C11.2847 2.74306 10.6944 2.5 10 2.5C9.30556 2.5 8.71528 2.74306 8.22917 3.22917C7.74306 3.71528 7.5 4.30556 7.5 5V7Z",
    fill: "#B6C2D6"
  })))));
};
export default SvgIcLock20;